export default __webpack_public_path__ + "static/slide2-other@2x-4b059b8fdefda3c492b0cb9fd0cd6725.png";